import { render, staticRenderFns } from "./OrganizationInspectionAttachmentsTable.vue?vue&type=template&id=78e76572&"
import script from "./OrganizationInspectionAttachmentsTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationInspectionAttachmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports